import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConstantsService } from './constants.service';

@Injectable({
	providedIn: 'root'
})
export class UsersService {

	constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }

	getUserInfo(toyotaGUID): Observable<any> {

		return this.http
			// ${toyotaGUID}
			.get(`${this.constantsService.baseAPIURL}/gi/getuserinfo/${toyotaGUID}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError)
			);
	}

	getUserInfoFreeze(toyotaGUID): Promise<any> {

		return this.http
			.get(`${this.constantsService.baseAPIURL}/gi/getuserinfo/${toyotaGUID}`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
	}


	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}



}
